import routes from '@routes';
import { CacheProps, fetchApi } from '../../../fetch';

interface OrderListProps extends CacheProps {
  moduleId?: string | undefined,
  limit: number,
  page: number,
  type: string
}

const getOrderListApi = ({ moduleId = undefined, limit = 100, page = 1, type, ...rest }: OrderListProps) => {
  return fetchApi({
    method: 'POST',
    URL: routes['api.order.list'],
    payload: {
      limit: limit,
      page: page,
      module_id: moduleId,
      type: type,
    },
    withToken: true,
    ...rest,
  });
};

export default getOrderListApi;
